import { createSlice } from '@reduxjs/toolkit';
import { omit } from 'ramda';

import { FetchStatus } from 'src/enums/FetchStatus';
import { Meta } from 'src/types/meta';
import { TimeTracking } from 'src/types/resources/TimeTracking';
import { ListResponse } from 'src/types/utils';
import { createAsyncAction } from 'src/utils/createAsyncAction';
import TimeTrackingRepository, { IndexParams } from 'src/repositories/superAdmin/TimeTrackingRepository';

export type TimeTrackingSliceStateType = {
  meta: Meta;
  timeTracking: TimeTracking[];
  index: {
    fetchStatus: FetchStatus;
    error: unknown;
  };
};

export type TimeTrackingSliceActionsType = {
  loadTimeTracking: (params?: IndexParams) => { unwrap: () => Promise<ListResponse<TimeTracking>> };
};

const initialState: TimeTrackingSliceStateType = {
  meta: {} as Meta,
  timeTracking: [],
  index: {
    fetchStatus: FetchStatus.idle,
    error: null,
  },
};

export const loadTimeTracking = createAsyncAction('superadmin/timeTracking/index', TimeTrackingRepository.index);

const timeTrackingSlice = createSlice({
  name: 'superadmin/timeTracking',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(loadTimeTracking.pending, state => {
      state.index.fetchStatus = FetchStatus.pending;
    });
    builder.addCase(loadTimeTracking.fulfilled, (state, { payload }) => {
      state.index.fetchStatus = FetchStatus.fulfilled;
      state.meta = omit(['results'], payload);
      state.timeTracking = payload.results;
    });
    builder.addCase(loadTimeTracking.rejected, state => {
      state.index.fetchStatus = FetchStatus.failed;
    });
  },
});

export default timeTrackingSlice.reducer;
